<span class="animated-shiny-text" [ngClass]="{'light-mode': ncTheme === 'light', 'dark-mode': ncTheme === 'dark'}"
    style="--shiny-width: {{ncShimmerWidth}}px">
    {{ncText}}
</span>